// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Gwre","tab":"ProcedureTabs_tab__328QW"};